__turbopack_context__.v({
  "active": "Slbgtq_active",
  "checkboxBox": "Slbgtq_checkboxBox",
  "checkboxBoxChecked": "Slbgtq_checkboxBoxChecked",
  "checkboxHidden": "Slbgtq_checkboxHidden",
  "checkboxLabel": "Slbgtq_checkboxLabel",
  "checkboxRow": "Slbgtq_checkboxRow",
  "checkboxSection": "Slbgtq_checkboxSection",
  "clearAll": "Slbgtq_clearAll",
  "filterBadge": "Slbgtq_filterBadge",
  "filterLabel": "Slbgtq_filterLabel",
  "filterLabelInfo": "Slbgtq_filterLabelInfo",
  "filterLabelText": "Slbgtq_filterLabelText",
  "filterSection": "Slbgtq_filterSection",
  "filterTab": "Slbgtq_filterTab",
  "filterTabClose": "Slbgtq_filterTabClose",
  "filterWrapper": "Slbgtq_filterWrapper",
  "numericInput": "Slbgtq_numericInput",
  "numericInputSection": "Slbgtq_numericInputSection",
  "numericInputWrapper": "Slbgtq_numericInputWrapper",
  "numericUnit": "Slbgtq_numericUnit",
  "panel": "Slbgtq_panel",
  "panelHeader": "Slbgtq_panelHeader",
  "tag": "Slbgtq_tag",
  "tagInput": "Slbgtq_tagInput",
  "tagRemove": "Slbgtq_tagRemove",
  "tagTextInput": "Slbgtq_tagTextInput",
});
